import { render, staticRenderFns } from "./CompetitionEditImage.vue?vue&type=template&id=cecec9f6&scoped=true&"
import script from "./CompetitionEditImage.vue?vue&type=script&lang=ts&"
export * from "./CompetitionEditImage.vue?vue&type=script&lang=ts&"
import style0 from "./CompetitionEditImage.vue?vue&type=style&index=0&id=cecec9f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cecec9f6",
  null
  
)

export default component.exports